import { RECEIVE_SESSION_STARTED, SET_LAST_ACTIVE, SET_SESSION_ALERT_ACTIVE, SET_SESSION_ALERT_INACTIVE } from './actions'

export const initialState = {
    sessionStarted: null,
    lastActive: null,
    sessionAlertActive: false
};


export const sessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case RECEIVE_SESSION_STARTED:
            return {
                ...state,
                sessionStarted: action.payload,
            };
        case SET_LAST_ACTIVE:
            return {
                ...state,
                lastActive: action.payload,
            };
        case SET_SESSION_ALERT_ACTIVE:
            return {
                ...state,
                sessionAlertActive: true,
            };
        case SET_SESSION_ALERT_INACTIVE:
            return {
                ...state,
                sessionAlertActive: false,
            };
        default:
            return state;
    }
};